module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/marketing-afiliate-4256b40c3ffefe8f3e3496301161ea41.jpg";